import SecureRouteContainer from './SecureRouteContainer'

export default SecureRouteContainer
